import {Button} from "react-bootstrap";
import React from "react";
import {useNavigate} from "react-router-dom";

export function GoBackConfig({state, edit}) {
    const navigate = useNavigate();

    const currentStep = state.currentStep
    const steps = state.steps

    const backTo = () => {
        const updatedState = {...state, currentStep: currentStep - 1}
        navigate(state && !edit ? steps[currentStep - 1] : -1, {state: updatedState})
    }
    return <>
        <Button variant="link" onClick={backTo}>Go back</Button>
    </>
}